import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import debounce from 'lodash.debounce';
import { useRef } from 'react';

/**
 * 侧边栏容器
 */
class ToTopBtnStore {
  @observable isActive;
  @observable showingHeight = 300;

  onListener = debounce(() => {
    // const windowHeight = document.documentElement.clientHeight;
    // const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = document.documentElement.scrollTop;

    this.isActive = scrollTop >= this.showingHeight;

    // if (windowHeight + scrollTop >= documentHeight - 30) {
    //   this.btnRef.current.style.position = 'absolute';
    //   window.removeEventListener('scroll', this.onListener);
    // }
  }, 10);

  scrollToTop = anchorName => {
    if (anchorName) {
      let anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  };

  use() {
    this.btnRef = useRef(null);
    useMount(() => {
      const onListener = this.onListener;
      window.addEventListener('scroll', onListener);
      return () => {
        window.removeEventListener('scroll', onListener);
      };
    });
  }
}

export default ToTopBtnStore;
